const capitalizeFirstLetter = (word) => {
  if (!word) return ""; // Handle empty or undefined strings
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export default capitalizeFirstLetter;
